(function () {
  function findClosestForm(el) {
    while (el && el !== document && el.nodeType === 1) {
      if (el.tagName === 'FORM' && /\/cart\/add/.test(el.getAttribute('action') || '')) return el;
      el = el.parentNode;
    }
    return null;
  }

  function getVariantAndQty(form) {
    var variantInput = form.querySelector('input[name="id"], select[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    return {
      id: variantInput && variantInput.value,
      qty: qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1
    };
  }

  async function addAndCheckout(form, btn) {
    var data = new FormData(form);
    var { id, qty } = getVariantAndQty(form);

    if (!id) {
      // נסיון בסיסי להכריח בחירת וריאנט
      var firstEmptySelect = form.querySelector('select option[value=""]:checked');
      if (firstEmptySelect) (firstEmptySelect.parentElement).focus();
      alert('בחר/י וריאנט לפני רכישה.');
      return;
    }

    if (!data.get('quantity')) data.set('quantity', qty || 1);

    btn.disabled = true;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      window.location.assign('/checkout');
    } catch (err) {
      console.error(err);
      alert('משהו השתבש. נסה/י שוב.');
    } finally {
      btn.disabled = false;
    }
  }

  function wireButtons(scope) {
    (scope || document).querySelectorAll('[data-quick-buy]').forEach(function (btn) {
      if (btn.dataset.qbWired) return;
      btn.dataset.qbWired = '1';

      btn.addEventListener('click', function () {
        var form = findClosestForm(btn) || document.querySelector('form[action^="/cart/add"]');
        if (!form) {
          alert('טופס המוצר לא נמצא בעמוד.');
          return;
        }
        addAndCheckout(form, btn);
      });
    });
  }

  // Initial
  wireButtons();

  // לכל מקרה של טעינות דינמיות בתמה
  document.addEventListener('shopify:section:load', function (e) { wireButtons(e.target); });
  document.addEventListener('shopify:section:select', function (e) { wireButtons(e.target); });
})();
